/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CmisAccessControlPrincipalType } from './cmisAccessControlPrincipalType';


export interface CmisAccessControlEntryType { 
    principal: CmisAccessControlPrincipalType;
    permission: Array<string>;
    direct?: boolean;
    any?: Array<object>;
}

